import { defineStore } from 'pinia';
import OrderReturn from '../entities/order-return';

export const useOrderReturnDetailsStore = defineStore('orderReturnDetails', {
	state: () => ({
		data: undefined,
		loading: true,
	}),
	getters: {
		acceptedCount(state) {
			if (!state.data) return 0;
			return state.data.products.reduce((count, product) => {
				return count + (product.accept_status == 1);
			}, 0);
		},
	},
	actions: {
		async fetchOrderReturn(id) {
			this.loading = true;
			try {
				const data = await OrderReturn.getOrderReturnById(id);
				this.data = data;
			} finally {
				this.loading = false;
			}
		},
		async refetchOrderReturn() {
			const data = await OrderReturn.getOrderReturnById(this.data.id);
			this.data = data;
		},
	},
});
